import env from '@/config/env';
import {errorGQLHandler, errorHandler} from '@/helpers/helpers';
import BUSCAR_ACESSO_RAPIDO from '@/graphql/revista/queries/BuscarAcessoRapido.gql';
import {getUF} from "@/utils/ufs";

export const Types = {
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export default {
  namespaced: true,
  state: {
    perPage: 100,
    barraAcesso: [],
    error: false
  },
  getters: {
    data: state => state.barraAcesso,
    error: state => state.error,
  },
  mutations: {
    [Types.REQUEST](state) {
      state.barraAcesso = [];
    },
    [Types.SUCCESS](state, payload) {
      state.barraAcesso = payload;
      state.error = false;
    },
    [Types.FAILURE](state) {
      state.error = true;
    },
  },
  actions: {
    async init({ commit, state }, perPage) {
      const limit = perPage || state.perPage;
      const uf = window.localStorage.getItem('revista.uf');
      commit(Types.REQUEST);

      if (uf) {
        try {
          const {
            data: {
              noticias: { data },
            },
          } = await env.apolloRevista.query({
            query: BUSCAR_ACESSO_RAPIDO,
            variables: {
              paginate: limit,
              modulo: env.revista.modulo,
              uf,
              canal: env.revista.canal,
            },
            fetchPolicy: 'no-cache',
          });
          commit(Types.SUCCESS, data);
        } catch (e) {
          commit(Types.FAILURE);
          errorGQLHandler(e);
        }
      }
    },
  },
};
